"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTML_SECTION_SHADOW_STYLES = void 0;
exports.buildHtmlSectionShadowStyles = buildHtmlSectionShadowStyles;
const inspectAttrs_1 = require("../admin-types/inspectAttrs");
const customization_1 = require("../api-types/customization");
const storefrontCssVariables_1 = require("./storefrontCssVariables");
/** Matches SECONDARY_FONT_CSS_VAR, which the storefront sets on :root. */
const SECONDARY_FONT_VAR = '--secondary-font';
/**
 * The only styles that apply inside an HTML section's shadow root, alongside
 * the author's own CSS. Shared so anything rendering a section outside the
 * storefront — a screenshot of one, say — reproduces what shoppers see.
 */
function buildHtmlSectionShadowStyles(enableShopperBrandSettings = customization_1.ENABLE_SHOPPER_BRAND_SETTINGS) {
    const mediaStyles = enableShopperBrandSettings
        ? `img, video {
    max-width: 100%;
    height: auto;
}
button {
    border-radius: var(${storefrontCssVariables_1.BUTTON_BORDER_RADIUS_VAR});
}`
        : `img {
    max-width: 100%;
    height: auto;
}`;
    return `
body, div, span, p, ul, li {
    font-family: inherit;
    color: inherit;
}
${mediaStyles}
img {
    max-height: 100svh;
    object-fit: contain;
}
[${inspectAttrs_1.INSPECT_ATTR.HTML_ROOT}] {
    overflow-x: hidden;
    overflow-x: clip;
}
h1, h2, h3, h4, h5, h6 {
    font-family: var(${SECONDARY_FONT_VAR});
}
::marker {
    color: inherit;
}
li.list-none {
    list-style-type: none;
}
li.list-none::before,
li.list-none::after {
    display: none;
}
`;
}
exports.HTML_SECTION_SHADOW_STYLES = buildHtmlSectionShadowStyles();
